import React, {Fragment, PureComponent} from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

import Loader from '../../../../shared/components/Loader/Loader.jsx';
import FormGlobalErrors from '../../../components/Form/FormGlobalErrors.jsx';
import AdditionalInfoStepForm from '../../../components/Forms/AdditionalInfoStepForm/AdditionalInfoStepForm.jsx';
import SubmitButton from '../../../components/Forms/AdditionalInfoStepForm/SubmitButton.jsx';

import conf from '../../../conf.js';

import './AdditionalInfoStep.scss';
import PrimaryButton from "../../../../shared/components/Styled/Buttons/PrimaryButton.jsx";

import {Col, Row} from "reactstrap";
import {CREATE_FREELANCE_STEPS, updateCreatFreelanceStep} from "../../../../shared/containers/Freelance/setNextStep.js";


export default class AdditionalInfoStep extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    freelance: PropTypes.object.isRequired,
    submit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      errors: null
    }
  }

  goNextStep = () => {
    const {agent, ...freelanceData} = this.props.freelance
    updateCreatFreelanceStep(
      freelanceData.id,
      CREATE_FREELANCE_STEPS.VISIO_RECAP,
      () => this.props.submit({
        freelance: {
          ...freelanceData
        },
        silentMode: true,
      })
    )
  }

  handleSubmit= (values) => {
    this.props.submit(values).then(() => {
      this.goNextStep()
    })
  }

  render() {
    const {freelance, ...props} = this.props;

    const initialValues = {
      user: props.currentUser,
      freelance: {
        ...freelance,
        work_permit: freelance?.work_permit ?? conf.workPermits.canadian.value,
        situation: freelance?.situation ?? conf.situations.search.value,
        date_available: freelance?.date_available ?? format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
        part_time: freelance?.part_time ?? conf.partTime.all.value,
      },
    };

    return <Fragment>
      <h2 className="text-center">Informations complémentaires</h2>

      <p className="text-center mb-5">
        Renseignez ici vos informations de disponibilité, mobilité et préférences de mandats.
      </p>
      <FormGlobalErrors errors={this.state.errors}/>
      <AdditionalInfoStepForm enableReinitialize={true} initialValues={initialValues} onSubmit={this.handleSubmit}/>
      <Row >
        <Col className="text-center mb-2 mb-sm-0">
          <PrimaryButton onClick={this.goNextStep}> Passer cette étape </PrimaryButton>
        </Col>
        <Col className="text-center">
          <SubmitButton className="mx-auto btn btn-primary">Valider mes informations</SubmitButton>
        </Col>
      </Row>
      <Loader visible={this.state.loading}>Sauvegarde des informations...</Loader>
    </Fragment>;
  }
}
